import { fmtTarikh } from "./ButirSheets";

export const PENYEL_ROWS_PER_PAGE = 10;

export function paginateRecords(records) {
  const pages = [];
  const chunks = Math.max(1, Math.ceil(records.length / PENYEL_ROWS_PER_PAGE));
  for (let i = 0; i < chunks; i++) {
    pages.push(records.slice(i * PENYEL_ROWS_PER_PAGE, (i + 1) * PENYEL_ROWS_PER_PAGE));
  }
  return pages;
}

export const PENYEL_CSS = `
  .penyel-doc { font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: #000; }
  .penyel-doc .sheet { width: 297mm; height: 210mm; background: #fff; padding: 10mm 12mm; box-sizing: border-box; display: flex; flex-direction: column; box-shadow: 0 4px 24px rgba(15,23,42,.18); overflow: hidden; }
  .penyel-doc .penyel-title { text-align: center; font-size: 15px; font-weight: bold; line-height: 1.5; margin: 2mm 0 5mm; }
  .penyel-doc .penyel-meta { font-size: 11px; margin-bottom: 2mm; display: flex; justify-content: space-between; }
  .penyel-doc .grid-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .penyel-doc .grid-table th, .penyel-doc .grid-table td { border: 1.2px solid #000; padding: 1mm 1.5mm; vertical-align: middle; word-wrap: break-word; }
  .penyel-doc .grid-table th { text-align: center; font-weight: bold; font-size: 10.5px; line-height: 1.35; }
  .penyel-doc .grid-table td { height: 12mm; font-size: 10px; line-height: 1.3; }
  .penyel-doc .center { text-align: center; }
  .penyel-doc .clamp3 { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
  .penyel-doc .nota { font-size: 10px; margin-top: 1.6mm; }
  .penyel-doc .sheet-footer { text-align: center; font-size: 11px; margin-top: auto; }
`;

export function PenyelSheet({ data, rows, footer }) {
  const v = data.vehicle;
  const blanks = Math.max(0, PENYEL_ROWS_PER_PAGE - rows.length);
  return (
    <div className="sheet">
      <div className="penyel-meta">
        <span><b>NO. PENDAFTARAN</b> : {v.registration_number} ({v.make} {v.model})</span>
        <span><b>BAHAGIAN/UNIT</b> : {data.agency.bahagian || data.agency.name}</span>
      </div>
      <div className="penyel-title">
        REKOD PENYELENGGARAAN BERJADUAL<br />(Diisi oleh Pemandu)
      </div>
      <table className="grid-table">
        <tbody>
          <tr>
            <th rowSpan={2} style={{ width: "9%" }}>Tarikh</th>
            <th rowSpan={2} style={{ width: "12%" }}>Bacaan<br />Odometer (km)</th>
            <th rowSpan={2} style={{ width: "33%" }}>Butir-butir penyelenggaraan<br />(seperti item di muka surat 5) dan<br />pemeriksaan berkala secara ringkas</th>
            <th rowSpan={2} style={{ width: "17%" }}>Nama/Tandatangan<br />Pegawai Yang<br />Mengesahkan</th>
            <th colSpan={2} style={{ width: "29%" }}>Jadual penyelenggaraan seterusnya</th>
          </tr>
          <tr>
            <th style={{ width: "14.5%" }}>Tarikh</th>
            <th style={{ width: "14.5%" }}>* Odometer (km)</th>
          </tr>
          {rows.map((r, i) => (
            <tr key={i}>
              <td className="center">{r.tarikh_masuk ? fmtTarikh(r.tarikh_masuk) : ""}</td>
              <td className="center">{r.odometer ? Number(r.odometer).toLocaleString() : ""}</td>
              <td><div className="clamp3">{r.butiran || (r.jenis ? `${r.jenis}${r.bengkel ? ` — ${r.bengkel}` : ""}` : "")}</div></td>
              <td>{r.pegawai || ""}</td>
              <td className="center">{r.jadual_tarikh ? fmtTarikh(r.jadual_tarikh) : ""}</td>
              <td className="center">{r.jadual_odometer ? Number(r.jadual_odometer).toLocaleString() : ""}</td>
            </tr>
          ))}
          {Array.from({ length: blanks }).map((_, i) => (
            <tr key={`b${i}`}>
              {Array.from({ length: 6 }).map((__, j) => <td key={j}>&nbsp;</td>)}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="nota">* Bagi kenderaan berat, Ketua Jabatan hendaklah membuat penyesuaian.</div>
      {footer && <div className="sheet-footer">{footer}</div>}
    </div>
  );
}
